// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"80f05591","513":"660fc507","703":"2a2f271d","787":"d1350a4e"}[chunkId] + ".chunk.js";
};